import { styled } from '~/styled'

export const SkeletonLoader = styled('div', {
  base: ['bg-grey-300', 'size-16', 'animate-shimmer']
})

SkeletonLoader.displayName = 'Skeleton'
